var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFocusCursor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6379 9.1283C14.897 7.29416 13.0996 6 11 6C8.23858 6 6 8.23858 6 11C6 13.0996 7.29416 14.897 9.1283 15.6379M10.9156 20.9997C5.43159 20.9543 1 16.4947 1 11C1 5.47715 5.47715 1 11 1C16.4947 1 20.9543 5.43159 20.9997 10.9156M11.0573 12.4235L13.6699 20.2614C13.9982 21.2462 15.3911 21.2462 15.7193 20.2614L16.6841 17.3672C16.7916 17.0447 17.0447 16.7916 17.3672 16.6841L20.2614 15.7193C21.2462 15.3911 21.2462 13.9982 20.2614 13.6699L12.4235 11.0573C11.5792 10.7758 10.7758 11.5792 11.0573 12.4235Z",
    stroke: "#464555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusCursor);
export default __webpack_public_path__ + "static/media/focusCursor.041f8f2d7be807cdb7c21e1442eb05e8.svg";
export { ForwardRef as ReactComponent };